<div class="expanded-panel-header pink" (click)="toggleExpand()">Pricing Details</div>
@if(expanded){
  <div class="row align-top" style="padding-left: 8px;padding-right: 8px;">
      <div class="col-md-6">
        <div class="row align-top" style="border-bottom: 1px solid lightgray">
          <div class="col-md-6 label">Response to Developer Needed</div>
          <div class="col-md-6">{{(data['Response to Developer Needed'] | date: 'MM/dd/yyyy') ?? '--'}}</div>
        </div>
        <div class="row align-top" style="border-bottom: 1px solid lightgray">
          <div class="col-md-6 label">Placement Guidance Expiration</div>
          <div class="col-md-6">{{(data['Placement Guidance Expiration'] | date: 'MM/dd/yyyy') ?? '--'}}</div>
        </div>
        <div class="row align-top" style="border-bottom: 1px solid lightgray">
          <div class="col-md-6 label">Placement Guidance Issued</div>
          <div class="col-md-6">{{(data['Placement Guidance Issued'] | date: 'MM/dd/yyyy') ?? '--'}}</div>
        </div>
      </div>
    <div class="col-md-6">
      <div class="row align-top" style="border-bottom: 1px solid lightgray">
        <div class="col-md-6 label">Non-CRA Execution</div>
        <div class="col-md-6">{{ detail.non_cra_execution ?? '--' }}</div>
      </div>
    </div>
  </div>
}
